<ion-content [fullscreen]="false" style="overflow: auto; overscroll-behavior: contain;">
  <ion-header [ngClass]="{'HeaderRounded': settingService.configuration?.welcomeOptions?.addWelcomeMessage && this.authservice.isAuthenticated}">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title>

        <div class="titleBar">

          {{ title  | translate }}

          
          @if (NotificationService.showNotificationBell) {
            <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
              <div class="bellimgContainer">
                <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
          

        </div>

      </ion-title>
      
    </ion-toolbar>

    <!--add this for the welcome message (ideally in its own component)-->
    @if(settingService.configuration?.welcomeOptions?.addWelcomeMessage && this.authservice.isAuthenticated) {
      <div class="WelcomeContainer">
        <div class="WelcomeMessage">
          {{ 'Welcome.Hi' | translate}} {{ this.authservice?.firstName }}
        </div>

        @if(this.primary){
          <div class="WelcomePointsContainer" [style.--points-container-color]="settingService.configuration?.welcomeOptions?.giftCardInfoContainerColor">
            <div class="GiftCardPoints">
              {{ this.primary?.PointsBalance + 'pts' }}
            </div>
            <div class="GiftCardAmmount">
              {{ this.primary?.GiftBalance | currency }}
            </div>
          </div>
        }
        
      </div>
    }
    

  </ion-header>

  <!-- add a margin if the "undocked navbar" is true (give or take 50-60 px)-->
  <div class="Content">
    @if(this.newsCategories.length > 0) {
      @for(category of this.newsCategories; track category; let first = $first){
        @if(!category.deactivate && category.news.length > 0) {
          <div class="CategorySeperator" [style.margin-top]="!first ? '0px' : null" [style.--btn-color]="category?.dayButtonColor?.dayButtonColor ?? '#ffffff'" [style.--btn-text-color]="category?.dayButtonColor?.dayButtonTextColor ?? '#000000'">
            <div class="CategoryTitle">
              {{ category.name?.translations[translationService.getLanguage()] }}
              <!--{{ textDisplay( category.name, translationService.getLanguage()) }}-->
            </div>

            @if(getCategoryDays(category.id); as categoryDays) {
              <div class="WeeklyDayListing">
                <!--cycle each day here-->
                @for(day of categoryDays.days; track day) {
                  @if(checkNewsBlogForDay(category, day)) {
                    <button class="DailyButton" [class.Selected]="day.selected" (click)="SelectNewsDay(day, category)">
                      {{ day.viewValue.translations[translationService.getLanguage()] }}
                    </button>
                  }
                }
              </div>
            }
            

            <div class="CarouselEvents">

              @for(news of getVisibleNews(category); track news; let first = $first){
                @if(shouldShowNews(news, category.id) && !news.deactivate || !category.weeklyFormat) {
                  <div class="EventCard" class="EventCard" [class.active]="isActiveNews(news, category)" [class.active-not-first]="isActiveNews(news, category) && !first" [class.not-active-first]="!isActiveNews(news, category) && first" (click)="setActiveNews(news, category); showmorenews(news)">
                    <div class="ImageContainer">
                      <img class="ImageStyle" [src]="getSrcImage(news, null)" alt="">
                    </div>
                    <div class="EventShortDetails">
                      <!--<div class="EventTitle detailSpacing" [innerHtml]="textDisplay(news.title, translationService.getLanguage())">-->
                      <div class="EventTitle detailSpacing" [innerHtml]="news.title?.translations[translationService.getLanguage()]">
                        <!--{{ news.title.translations[translationService.getLanguage()] }}-->
                      </div>
                      <!--<div class="EventDetail" [ngClass]="{'noTextWrap': news.pricingReference?.showPricing,'detailSpacing': news.pricingReference?.showPricing}" [innerHtml]="news.shortDescription?.translations[translationService.getLanguage()]">-->
                      <div class="EventDetail" [ngClass]="{'noTextWrap': news.pricingReference?.showPricing,'detailSpacing': news.pricingReference?.showPricing}" [innerHtml]="news.shortDescription?.translations[translationService.getLanguage()]">
                        <!--{{ news.shortDescription.translations[translationService.getLanguage()] }}-->
                      </div>
                      @if(news.pricingReference?.showPricing){
                        <div class="EventPrice">
                          {{ news.pricingReference?.price | currency }}
                          
                        </div>
                      }
                    </div>
                  </div>
                }
                
              }

              
            </div>
          </div>
        }
        
      }

      
    }

    @if(this.blogsCategories.length > 0) {
      @for(category of this.blogsCategories; track category; let first = $first){
        @if(!category.deactivate && category.blogs.length > 0) {
          <div class="CategorySeperator" [style.margin-top]="this.newsCategories.length > 0 || !first ? '0px' : null" [style.--btn-color]="category?.dayButtonColor?.dayButtonColor ?? '#ffffff'" [style.--btn-text-color]="category?.dayButtonColor?.dayButtonTextColor ?? '#000000'">
            <div class="CategoryTitle">
              {{ category.name?.translations[translationService.getLanguage()] }}
              <!--{{ textDisplay(category.name, translationService.getLanguage()) }}-->
            </div>

            @if(getCategoryDays(category.id); as categoryDays) {
              <div class="WeeklyDayListing">
                <!--cycle each day here-->
                @for(day of categoryDays.days; track day) {
                  @if(checkNewsBlogForDay(category, day)) {
                    <button class="DailyButton" [class.Selected]="day.selected" (click)="SelectBlogsDay(day, category)">
                      {{ day.viewValue.translations[translationService.getLanguage()] }}
                    </button>
                  }
                }
              </div>
            }
            

            <div class="CarouselEvents">

              @for(blog of getVisibleBlogs(category); track blog; let first = $first){
                @if(shouldShowBlog(blog, category.id) && !blog.deactivate || !category.weeklyFormat) {
                  <div class="EventCard" class="EventCard" [class.active]="isActiveBlog(blog, category)" [class.active-not-first]="isActiveBlog(blog, category) && !first" [class.not-active-first]="!isActiveBlog(blog, category) && first" (click)="setActiveBlog(blog, category); showmoreblog(blog, getCategoryDays(category.id))">
                    <div class="ImageContainer">
                      <img class="ImageStyle" [src]="getSrcImage(null, blog)" alt="">
                    </div>
                    <div class="EventShortDetails">
                      <!--<div class="EventTitle detailSpacing" [innerHtml]="textDisplay(blog.title, translationService.getLanguage())">-->
                      <div class="EventTitle detailSpacing" [innerHtml]="blog.title?.translations[translationService.getLanguage()]">
                        <!--{{ blog.title.translations[translationService.getLanguage()] }}-->
                      </div>
                      
                      <!--<div class="EventDetail" [ngClass]="{'noTextWrap': blog.pricingReference?.showPricing,'detailSpacing': blog.pricingReference.showPricing}" [innerHtml]="blog.shortDescription?.translations[translationService.getLanguage()]">-->
                      <div class="EventDetail" [innerHtml]="blog.shortDescription?.translations[translationService.getLanguage()]">
                        <!--{{ blog.shortDescription.translations[translationService.getLanguage()] }}-->
                      </div>
                      @if(blog.pricingReference?.showPricing){
                        <div class="EventPrice">
                          {{ blog.pricingReference?.price | currency }}
                        </div>
                      }
                    </div>
                  </div>
                }
                
              }

              
            </div>
          </div>
        }
        
      }

      
    }
  </div>
</ion-content>
